/**
 * Last-resort UI for an unrecoverable render error (OPS-2026-002).
 * Rendered by the root `Sentry.ErrorBoundary` in `main.tsx` — before this
 * existed, a render crash left the admin staring at a blank white page with
 * no signal to anyone.
 */
export function CrashFallback() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center">
      <h1 className="text-lg font-semibold">Something went wrong</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        The page failed to load. The error has been reported to our team.
        Reloading usually fixes it.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="mt-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
      >
        Reload page
      </button>
    </div>
  );
}
